import React from 'react'

const Footer = () => {
  return (
    <div className='fixed-bottom bg-dark py-4 text-center mt-4 text-white'>Copyright 2022 @Gallery</div>
  )
}

export default Footer